module.exports = __webpack_public_path__ + "static/media/microphone-muted.d33c01b7.svg";